<template>
  <div class="call">
    <div class="top">联系我们</div>
    <div class="main">
      <div class="main-inner">
        <div class="block" v-for="(item, index) in block1" :key="index">
          <p class="title b">{{ item.title }}</p>
          <p class="subtitle">{{ item.subtitle }}</p>
          <ul class="flex-top flex-wrap hq">
            <li v-for="(item2, index2) in item.attrlist" :key="index2">
              <p>{{ item2.title }}</p>
            </li>
          </ul>
        </div>

        <div class="block">
          <p class="title b">分公司</p>
          <ul class="list_r">
            <li v-for="(item, index) in block2" :key="index">
              <p class="s-title b">{{ item.title }}</p>
              <p>{{ item.subtitle }}</p>
              <p v-for="(item2, index2) in item.attrlist" :key="index2">
                {{ item2.title }}
              </p>
            </li>
          </ul>
        </div>
        <div class="block">
          <p class="title b">子公司</p>
          <ul class="list_t">
            <li v-for="(item, index) in block3" :key="index">
              <p>{{ item.title }}</p>
              <p>{{ item.subtitle }}</p>
              <p v-for="(item2, index2) in item.attrlist" :key="index2">
                {{ item2.title }}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topbanner: {
        // title:'联系我们',
        // entitle:'Contact Us',
      },
      block1: [],
      block2: [],
      block3: [],
    };
  },
  mounted() {
    //获取到配置的头部颜色，听过store监听动态改变
    this.$store.commit("until/SET_COLOR", "#000");
    this.getData();
  },
  methods: {
    getData() {
      this.$fetch({
        url: "index.php/contactus/initPage",
      }).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          this.topbanner = res.data.topbanner;
          this.block1 = res.data.comptypes[0].complist;
          this.block2 = res.data.comptypes[1].complist;
          this.block3 = res.data.comptypes[2].complist;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.call {
  padding-top: 68px;
  border-top: 1px solid #d4d4d4;
}
.top {
  font-size: 36px;
  font-weight: 600;
  color: #333333;
  line-height: 50px;
  letter-spacing: 4px;
  text-align: center;
}
.main .list_t li,
.main .list_r li{
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
}
.main .main-inner .block .list_t li p:nth-child(1) {
  font-size: 28px;
  font-weight: 600;
  color: #333333;
  line-height: 40px;
}
.main .main-inner .block .list_t li {
  margin-bottom: 30px;
}
.main .main-inner .block .list_t li p {
  margin-bottom: 15px;
}
.main .main-inner .block .subtitle {
  margin-bottom: 3vw !important;
}
.main .main-inner .block ul li p {
  margin-bottom: 3vw !important;
}
.main {
  padding: 50px 0 70px;
  .main-inner {
    width: 690px;
    margin: 0 auto;
    .block {
      margin-bottom: 28px;
      // border-bottom: 1px solid #ccc;
      .title {
        font-size: 36px;
        font-weight: 600;
        color: #396aff;
        line-height: 50px;
        margin-bottom: 27px;
      }
      .subtitle {
        font-size: 24px;
        color: #999999;
        line-height: 20px;
        margin-bottom: 15px;
      }
      ul {
        li {
          p {
            font-size: 24px;
            color: #999999;
            line-height: 20px;
            margin-bottom: 15px;
          }
          .s-title {
            color: #000000;
            margin-bottom: 15px;
            margin-top: 35px;
          }
        }
      }
    }
  }
}
</style>